import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const COPY = defineMessages({
  TOOLTIP_ARIA_ROLE_DESC: {
    id: 'Pricing.copy.TooltipAriaRoleDesc',
    defaultMessage: 'A tooltip describing the functionality of the feature',
    desc: {
      id: 'Pricing.copy.TooltipAriaRoleDesc',
      message: '[Type: aria role description][Vis: low] - Accessibility description for cell',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
